import { jsx as _jsx } from "react/jsx-runtime";
import { useMediaQuery } from '../../hooks/useMediaQuery';
import { Sheet } from '../Sheet';
import { DesktopDialog } from './Dialog.Desktop';
/**
 * Responsive dialog — a centered Radix Themes Dialog from 640px up, the local
 * `Sheet` (bottom sheet) below it. Same prop surface as `Sheet`, plus a
 * desktop-only `width`. The `width` prop is harmlessly ignored on the sheet.
 *
 * Duplicated from the app's `components/Dialog` for this tsc-only package;
 * remove once these overlays are shared.
 */
export function Dialog(props) {
    const isDesktop = useMediaQuery('(min-width: 640px)');
    return isDesktop ? _jsx(DesktopDialog, { ...props }) : _jsx(Sheet, { ...props });
}
